// HOOKS
import { useMutation } from "@apollo/client";
// GRAPHQL
import { CREATE_PERMISSION } from "../../../graphql/mutations/users/permissions.users.mutation";

const useCreatePermission = () => {
  const [createPermissionMutation, { loading, error }] =
    useMutation(CREATE_PERMISSION);

  const createPermission = async (permission) => {
    try {
      // Split tags by comma and trim white space
      if (permission.tags) {
        permission.tags = permission.tags.split(",").map((tag) => tag.trim());
      }
      const { data } = await createPermissionMutation({
        variables: { permission },
      });
      return data.createPermission;
    } catch (error) {
      console.error({ error });
      return error;
    }
  };
  return { createPermission, loading, error };
};

export default useCreatePermission;
